<template>
  <div class="flex flex-wrap items-center gap-x-4">
    <span class="label-medium text-static-default-low">
      {{
        i18n(translations.lastLowestPrice, {
          price: i18n.price(normalizePrice(lastLowestPrice)),
        })
      }}
    </span>

    <RevTooltip class="label-medium text-static-default-low">
      <template #trigger="{ show, hide }">
        <IconInfo
          :aria-label="i18n(translations.moreInfoSRLabel)"
          class="inline align-top"
          size="16"
          @focusin="show"
          @focusout="hide"
          @mouseleave="hide"
          @mouseover="show"
        />
      </template>
      {{ label }}
    </RevTooltip>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { Price } from '@backmarket/core-types/Price'
import type { PriceNumber } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { RevTooltip } from '@ds/components/Tooltip'
import { IconInfo } from '@ds/icons/IconInfo'

import { getSellerFlashSalesPeriod } from '../../helpers/getSellerFlashSalesPeriod/getSellerFlashSalesPeriod'
import { normalizePrice } from '../../helpers/normalizePrice/normalizePrice'

import translations from './LastLowestPrice.translations'

const i18n = useI18n()
const locale = useI18nLocale()

defineProps<{
  lastLowestPrice: Price | PriceNumber
}>()

const label = computed(() => {
  const { startDate, endDate } = getSellerFlashSalesPeriod(new Date())
  const dateFormat: Intl.DateTimeFormatOptions = {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
  }

  return i18n(translations.sellerFlashSalesDiscountTooltip, {
    start_date: startDate.toLocaleDateString(locale, dateFormat),
    end_date: endDate.toLocaleDateString(locale, dateFormat),
  })
})
</script>
